import { Injectable } from '@angular/core';
import { IID_OL_RISORSA } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDolRisorsaStore } from './iidOlRisorsa.store';
import { IIDolRisorsaQuery } from './iidOlRisorsa.query';
import { WsACKCallback } from '@common/api/ack';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.OLO_RISORSA)
export class IIDolRisorsaService extends CrudService<IID_OL_RISORSA, IIDolRisorsaStore, IIDolRisorsaQuery> {
  constructor(
    protected store: IIDolRisorsaStore,
    public query: IIDolRisorsaQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService) {
    super(
      Topics.IID_OL_RISORSA,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  makeReservation(issueId: string, callback?: WsACKCallback<IID_OL_RISORSA>) {
    const dto = { issueId };
    this.featureCommandService.send<IID_OL_RISORSA>(
      {
        target: 'feature:signal',
        command: 'risorsa:reservation',
        dto,
        ...this.projectIdFromIssue(issueId),
      },
      () => this.actionService.sendMessage(Topics.IID_OL_RISORSA, 'reservation', dto, callback),
      callback,
    );
  }

  completeReservation(issueId: string, callback?: WsACKCallback<IID_OL_RISORSA>) {
    const dto = { issueId };
    this.featureCommandService.send<IID_OL_RISORSA>(
      {
        target: 'feature:signal',
        command: 'risorsa:complete-reservation',
        dto,
        ...this.projectIdFromIssue(issueId),
      },
      () => this.actionService.sendMessage(Topics.IID_OL_RISORSA, 'complete_reservation', dto, callback),
      callback,
    );
  }

  releaseSignal(issueId: string, callback?: WsACKCallback<IID_OL_RISORSA>) {
    const dto = { issueId };
    this.featureCommandService.send<IID_OL_RISORSA>(
      {
        target: 'feature:signal',
        command: 'risorsa:release-signal',
        dto,
        ...this.projectIdFromIssue(issueId),
      },
      () => this.actionService.sendMessage(Topics.IID_OL_RISORSA, 'release_signal', dto, callback),
      callback,
    );
  }

  refreshFromGisfo(issueId: string, callback?: WsACKCallback<IID_OL_RISORSA>) {
    const dto = { issueId };
    this.featureCommandService.send<IID_OL_RISORSA>(
      {
        target: 'feature:signal',
        command: 'risorsa:refresh',
        dto,
        ...this.projectIdFromIssue(issueId),
      },
      () => this.actionService.sendMessage(Topics.IID_OL_RISORSA, 'refresh', dto, callback),
      callback,
    );
  }

  private projectIdFromIssue(issueId: string): { projectId?: string } {
    const projectId = this.query.getByIssueId(issueId)?.[0]?.projectId;
    return projectId ? { projectId } : {};
  }
}
